import { IconRender, InheritProps } from '../../IconRender';

export function ButtonIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="1" y="1" width="48" height="78" rx="7" fill="#343434" stroke={color} strokeWidth="4"/>
          <rect x="7" y="63" width="36" height="9" rx="4.5" fill="#D9D9D9"/>
        </>
      )}
    />
  );
}
